import { Injectable } from '@angular/core';
import { AblaufDatumService, BackendOberflaecheService, IAblaufDatumService } from '@vhv/tarifrechner-common';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class VersicherungsablaufBaugeraeteService implements IAblaufDatumService{

    private readonly dateFormat:string = 'dd.MM.yyyy';

    constructor(private readonly commonAblaufDatumService: AblaufDatumService,
    private _inputBackendOberflaecheService: BackendOberflaecheService) {
        this.commonAblaufDatumService.setSpecializedAblaufDatumService(this);
    }

    /**
     * Berechnet den Versicherungsablauf. Dies ist immer der XX.XX. des nächsten Jahres.
     * Ausnahme: Versicherungsbeginn ist am 02.06. dann ist das Ablaufdatum der 02.06. des nächsten Jahres.
     *
     * @param versicherungsBeginn der Versicherungsbeginn im Format: DD.MM.YYYY
     */
    getAblaufDatum(versicherungsBeginn: string): string {
        const datum = DateTime.fromFormat(versicherungsBeginn, this.dateFormat);
        return datum.plus({years:+this._inputBackendOberflaecheService.getElementByName("Vertragslaufzeit").value}).toFormat(this.dateFormat);
    }
}
